import React from "react";

const VolumeOffIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    width="23"
    height="16"
    viewBox="0 0 23 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 1.00C11 0.61 10.77 0.26 10.43 0.09C10.08 -0.06 9.67 -0.02 9.37 0.21L4.64 4.00H1C0.44 4.00 0 4.44 0 5.00V11C0 11.55 0.44 12 1 12H4.64L9.37 15.78C9.67 16.02 10.08 16.06 10.43 15.90C10.77 15.73 11 15.38 11 15V1.00ZM5.62 5.78L9 3.08V12.91L5.62 10.21C5.44 10.07 5.22 10 5 10H2V6H5C5.22 6 5.44 5.92 5.62 5.78ZM22.70 4.29C23.09 4.68 23.09 5.31 22.70 5.70L20.41 8L22.70 10.29C23.09 10.68 23.09 11.31 22.70 11.70C22.31 12.09 21.68 12.09 21.29 11.70L19 9.41L16.70 11.70C16.31 12.09 15.68 12.09 15.29 11.70C14.90 11.31 14.90 10.68 15.29 10.29L17.58 8L15.29 5.70C14.90 5.31 14.90 4.68 15.29 4.29C15.68 3.90 16.31 3.90 16.70 4.29L19 6.58L21.29 4.29C21.68 3.90 22.31 3.90 22.70 4.29Z"
      fill={fillColor}
    />
  </svg>
);

export default VolumeOffIcon;
